import {createSelectorCreator, defaultMemoize} from 'reselect'
import {createCachedSelector} from 're-reselect'
import _ from 'lodash'
import {findRecord, inverseFilterRecords, filterRecords} from '../record_selection'
import {allExternal} from './all_selector'
import {normalizeKind} from '../record_building/record_keys'

const createDeepEqualSelector = createSelectorCreator(defaultMemoize, _.isEqual)

const recordQueryCacheKey = (state, key, query, opts) => `${normalizeKind(key)}-${JSON.stringify(query)}-${JSON.stringify(opts)}`
const recordQuerySelectorOptions = {
	keySelector: recordQueryCacheKey,
	selectorCreator: createDeepEqualSelector,
}

export const find = createCachedSelector(
	allExternal,
	(state, key) => normalizeKind(key),
	(state, key, query) => query,
	(state, key, query, opts) => opts || '',
	(records, key, query) => findRecord(records, query) || {},
)(recordQuerySelectorOptions)

export const where = createCachedSelector(
	allExternal,
	(state, key) => normalizeKind(key),
	(state, key, query) => query,
	(state, key, query, opts) => opts || '',
	(records, key, query) => (query ? filterRecords(records, query) : records || []),
)(recordQuerySelectorOptions)

export const whereNot = createCachedSelector(
	allExternal,
	(state, key) => normalizeKind(key),
	(state, key, query) => query,
	(state, key, query, opts) => opts || '',
	(records, key, query) => inverseFilterRecords(records, query) || [],
)(recordQuerySelectorOptions)
